export const SHOW_UNSAVED_CHANGES_CONFIRMATION =
  'unsavedChangesConfirmation/SHOW_UNSAVED_CHANGES_CONFIRMATION';
export const HIDE_UNSAVED_CHANGES_CONFIRMATION =
  'unsavedChangesConfirmation/HIDE_UNSAVED_CHANGES_CONFIRMATION';
